import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

export default function ImpersonationBanner() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const originalToken = useAuthStore((s) => s.originalToken);
  const user = useAuthStore((s) => s.user);
  const stopImpersonating = useAuthStore((s) => s.stopImpersonating);

  if (!originalToken) return null;

  const handleStop = () => {
    stopImpersonating();
    navigate('/admin');
  };

  const name = user ? `${user.firstName} ${user.lastName}`.trim() || user.email : '';

  return (
    <div className="sticky top-0 z-30 bg-amber-500 text-white shadow-sm">
      <div className="flex w-full items-center justify-between gap-4 px-4 py-2 text-sm">
        <div className="flex items-center gap-2">
          <ExclamationTriangleIcon className="h-5 w-5 shrink-0" />
          <span>
            {t('admin.impersonating', { name })}
          </span>
        </div>
        <button
          type="button"
          onClick={handleStop}
          className="rounded-md bg-white/20 px-3 py-1 text-xs font-semibold hover:bg-white/30"
        >
          {t('admin.actions.stopImpersonating')}
        </button>
      </div>
    </div>
  );
}
